"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e="undefined"!=typeof document&&document.querySelector("html"),t="undefined"!=typeof window?window.getComputedStyle(e,null).getPropertyValue("font-size"):"",r=(""!==t?parseFloat(t):16)/16*16;exports.default=(...e)=>{let t="";for(let o=0;o<e.length;++o){let u=e[o];""!==t&&(t+=" ");let l=(n=u,{number:parseFloat(n),units:String(n).replace(/^[\d.-]+/,"")});"rem"!==l.units?t+=l.number/r:t+=l.number,0!=l.number&&(t+="rem")}var n;return t},exports.remBase=16;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/JavaScriptStyleHelpers/calculateRem.js
// module id = 897
// module chunks = 0